var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enterprise",
    transform: "translate(-1281.000000, -11827.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1281.000000, 11827.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-5",
    fill: "#EFF7FF",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-cloud-search-MCNWTJKPLS",
    transform: "translate(13.000000, 19.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9983399,39 L16.1230025,39 C7.98512392,38.9688667 1.13690919,33.2784389 0.126439122,25.7078805 C-0.88403095,18.137322 4.25739317,11.0402776 12.1361555,9.13008228 C14.0512562,3.38236526 19.9235896,-0.381853636 26.3313201,0.0308533242 C32.7390505,0.443560284 38.0071501,4.92530847 39.065873,10.8645625 C44.0061784,10.4383249 48.850657,12.3353022 52,15.9292448 L48.4340383,18.6914046 C45.7965113,15.6899456 41.507265,14.4472418 37.5233979,15.5303143 L34.4268851,16.3650329 L34.6234524,12.9372664 C34.558203,8.49748833 30.9266728,4.82107052 26.210009,4.4198285 C21.4933453,4.01858648 17.2153095,7.02214517 16.2987568,11.3784023 L15.9958119,12.8960725 L14.3770225,13.1258911 C8.45691962,14.0347706 4.26142927,19.0373849 4.71604818,24.6454334 C5.17066709,30.253482 10.1243876,34.6041775 16.1230025,34.6637994 L29.9983399,34.6637994 L29.9983399,39 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,39 C37.0294373,39 33,34.9705627 33,30 C33,25.0294373 37.0294373,21 42,21 C46.9705627,21 51,25.0294373 51,30 C51,32.3869484 50.0517884,34.6761336 48.363961,36.363961 C46.6761336,38.0517884 44.3869484,39 42,39 Z M42,25.5 C39.5147186,25.5 37.5,27.5147186 37.5,30 C37.5,32.4852814 39.5147186,34.5 42,34.5 C44.4852814,34.5 46.5,32.4852814 46.5,30 C46.5,27.5147186 44.4852814,25.5 42,25.5 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(49.000000, 38.500000) rotate(-45.000000) translate(-49.000000, -38.500000) ",
    x: 47,
    y: 34,
    width: 4,
    height: 9
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCloud);
export default __webpack_public_path__ + "static/media/search-cloud.c0b7d7e682d0abbb314824dfb7104a87.svg";
export { ForwardRef as ReactComponent };